/* eslint-disable */
// biome-ignore-all lint: auto-generated
// biome-ignore-all format: auto-generated
// biome-ignore-all assist: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: bun run autoexport.
//

import type { Bytes, ExtractPageResult, GetBlockPointer, ICCPointer, IsDataAvailPointer, PageNumber, PageResult, PdfReaderPointer, Pixel, PlotPageEntry, Rectangle } from "../types/Types"
import type { Float, Integer, Result } from "@pdfking/tfunc"
import { FullMethodDispatcher, StringToUInt8, UInt8ToString } from "@pdfking/tfunc"
import type { RuntimeBridge } from "@pdfking/wasm-core"
const enum F {
    init = "$1n",
    destroy = "$1g",
    open = "$1k",
    doc_avail = "$a",
    page_avail = "$18",
    page_count = "$q",
    open_mem = "$9",
    close_mem = "$e",
    close = "$1p",
    extract_page = "$p",
    split_page = "$1c",
    convert_jpeg = "$s",
    convert_bitmap = "$g",
    icc_create = "$8",
    icc_destroy = "$1a",
    rasterize_page = "$w",
    plot = "$1"
}
type CallReturn = {
    [F.init]: void
    [F.destroy]: void
    [F.open]: bigint
    [F.doc_avail]: bigint
    [F.page_avail]: bigint
    [F.page_count]: bigint
    [F.open_mem]: bigint
    [F.close_mem]: bigint
    [F.close]: bigint
    [F.extract_page]: bigint
    [F.split_page]: bigint
    [F.convert_jpeg]: bigint
    [F.convert_bitmap]: bigint
    [F.icc_create]: bigint
    [F.icc_destroy]: bigint
    [F.rasterize_page]: bigint
    [F.plot]: bigint
}
export const NativeSymbols: Record<string, "std" | "next"> = { "$1n": "std", "$1g": "std", "$1k": "std", "$a": "std", "$18": "std", "$q": "std", "$9": "std", "$e": "std", "$1p": "std", "$p": "std", "$1c": "std", "$s": "std", "$g": "std", "$8": "std", "$1a": "std", "$w": "std", "$1": "std" }
const u32_b = (v: number) => new Uint8Array(new Uint32Array([v]).buffer)
function* str_b(s: string): Generator<Uint8Array> { const b = StringToUInt8(s); yield u32_b(b.length); const p = new Uint8Array((b.length + 3) & ~3); p.set(b); yield p; }
const f64_b = (v: number) => { const b = new Uint8Array(8); new DataView(b.buffer).setFloat64(0, v, true); return b; }
const i64_b = (v: bigint) => { const b = new Uint8Array(8); new DataView(b.buffer).setBigInt64(0, v, true); return b; }
const u64_b = (v: bigint) => { const b = new Uint8Array(8); new DataView(b.buffer).setBigUint64(0, v, true); return b; }
const u256_b = (v: bigint) => { const b = new Uint8Array(32); for (let i = 0; i < 4; i++) {
    new DataView(b.buffer).setBigUint64(i * 8, (v >> BigInt(i * 64)) & 0xffffffffffffffffn, true)
} return b; }
type type_SpatialRectangle = {
    height: type_Pixel
    width: type_Pixel
    x: type_Pixel
    y: type_Pixel
}
type type_Rectangle = {
    height: type_Pixel
    width: type_Pixel
}
type type_PlotMediaEntry = {
    bytes: Uint8Array
    id: type_GUID
}
type type_PlotPage = {
    height: type_Pixel
    trim_bottom: type_Pixel
    trim_left: type_Pixel
    trim_right: type_Pixel
    trim_top: type_Pixel
    width: type_Pixel
}
type type_PlotShape = {
    enum: "plot_rect"
} & type_PlotShapeRect | {
    enum: "plot_media"
} & type_PlotShapeMedia | {
    enum: "plot_path"
} & type_PlotShapePath | {
    enum: "plot_text"
} & type_PlotShapeText
type type_PlotShapeRect = {
    fill: type_PlotColor
    height: type_Pixel
    rotation: type_Degree
    stroke: type_PlotColor
    stroke_width: type_Pixel
    width: type_Pixel
    x: type_Pixel
    y: type_Pixel
}
type type_PlotColor = {
    enum: "rgb"
} & type_RGBColor | {
    enum: "cmyk"
} & type_CMYKColor
type type_RGBColor = {
    alpha: type_ColorComponent
    blue: type_ColorComponent
    green: type_ColorComponent
    red: type_ColorComponent
}
type type_CMYKColor = {
    alpha: type_ColorComponent
    black: type_ColorComponent
    cyan: type_ColorComponent
    magenta: type_ColorComponent
    yellow: type_ColorComponent
}
type type_PlotShapeMedia = {
    crop: type_SpatialRectangle
    media: type_SpatialRectangle
    media_index: type_GUID
    rotation: type_Degree
    scale: type_Scale
}
type type_Scale = {
    x: type_Percentage
    y: type_Percentage
}
type type_PlotShapePath = {
    closed: boolean
    fill: type_PlotColor
    points: readonly type_Point[]
    stroke: type_PlotColor
    stroke_width: type_Pixel
}
type type_Point = {
    x: type_Pixel
    y: type_Pixel
}
type type_PlotShapeText = {
    color: type_PlotColor
    font_name: string
    font_size: type_Pixel
    height: type_Pixel
    horizontal_align: type_HorizontalAlign
    rotation: type_Degree
    text: string
    vertical_align: type_VerticalAlign
    width: type_Pixel
    x: type_Pixel
    y: type_Pixel
}
type type_HorizontalAlign = "center" | "left" | "right"
type type_VerticalAlign = "center" | "bottom" | "top"
type type_PdfReaderPointer = Integer<"PdfReaderPointer", "usize">
type type_Pixel = Float<"Pixel">
type type_ICCPointer = Integer<"ICCPointer", "usize">
type type_GUID = Integer<"GUID", "u256">
type type_ColorComponent = Float<"ColorComponent">
type type_Degree = Float<"Degree">
type type_Percentage = Float<"Percentage">
type Cursor = {
    i8(): bigint
    u8(): bigint
    i16(): bigint
    u16(): bigint
    i32(): bigint
    u32(): number
    f32(): number
    f64(): number
    i64(): bigint
    u64(): bigint
    i128(): bigint
    u128(): bigint
    i256(): bigint
    u256(): bigint
    ptr(): number
    bool(): boolean
    str(): string
    bytes(): Uint8Array
}
function* enc_SpatialRectangle(v: type_SpatialRectangle): Generator<Uint8Array> {
    yield f64_b(v.height)
    yield f64_b(v.width)
    yield f64_b(v.x)
    yield f64_b(v.y)
}
function* enc_Rectangle(v: type_Rectangle): Generator<Uint8Array> {
    yield f64_b(v.height)
    yield f64_b(v.width)
}
function* enc_PlotPage(v: type_PlotPage): Generator<Uint8Array> {
    yield f64_b(v.height)
    yield f64_b(v.trim_bottom)
    yield f64_b(v.trim_left)
    yield f64_b(v.trim_right)
    yield f64_b(v.trim_top)
    yield f64_b(v.width)
}
function* enc_2z0guf1ofm03r(v: readonly type_PlotShape[]): Generator<Uint8Array> {
    yield u32_b(v.length)
    for (const el of v)
        yield* enc_PlotShape(el)
}
const enc_PlotShape = FullMethodDispatcher<[
    type_PlotShape
], Generator<Uint8Array>>({
    plot_rect: function* (v) {
        yield u64_b(2623146974357031720n)
        yield* enc_PlotShapeRect((v as type_PlotShapeRect))
    },
    plot_media: function* (v) {
        yield u64_b(15763006351657656862n)
        yield* enc_PlotShapeMedia((v as type_PlotShapeMedia))
    },
    plot_path: function* (v) {
        yield u64_b(12387705824372953871n)
        yield* enc_PlotShapePath((v as type_PlotShapePath))
    },
    plot_text: function* (v) {
        yield u64_b(15543078606723183421n)
        yield* enc_PlotShapeText((v as type_PlotShapeText))
    },
})
function* enc_PlotShapeRect(v: type_PlotShapeRect): Generator<Uint8Array> {
    yield* enc_PlotColor(v.fill)
    yield f64_b(v.height)
    yield f64_b(v.rotation)
    yield* enc_PlotColor(v.stroke)
    yield f64_b(v.stroke_width)
    yield f64_b(v.width)
    yield f64_b(v.x)
    yield f64_b(v.y)
}
const enc_PlotColor = FullMethodDispatcher<[
    type_PlotColor
], Generator<Uint8Array>>({
    rgb: function* (v) {
        yield u64_b(1219284763885334403n)
        yield* enc_RGBColor((v as type_RGBColor))
    },
    cmyk: function* (v) {
        yield u64_b(11496881286487159691n)
        yield* enc_CMYKColor((v as type_CMYKColor))
    },
})
function* enc_RGBColor(v: type_RGBColor): Generator<Uint8Array> {
    yield f64_b(v.alpha)
    yield f64_b(v.blue)
    yield f64_b(v.green)
    yield f64_b(v.red)
}
function* enc_CMYKColor(v: type_CMYKColor): Generator<Uint8Array> {
    yield f64_b(v.alpha)
    yield f64_b(v.black)
    yield f64_b(v.cyan)
    yield f64_b(v.magenta)
    yield f64_b(v.yellow)
}
function* enc_PlotShapeMedia(v: type_PlotShapeMedia): Generator<Uint8Array> {
    yield* enc_SpatialRectangle(v.crop)
    yield* enc_SpatialRectangle(v.media)
    yield u256_b(v.media_index)
    yield f64_b(v.rotation)
    yield* enc_Scale(v.scale)
}
function* enc_Scale(v: type_Scale): Generator<Uint8Array> {
    yield f64_b(v.x)
    yield f64_b(v.y)
}
function* enc_PlotShapePath(v: type_PlotShapePath): Generator<Uint8Array> {
    yield u32_b(v.closed
        ? 1 : 0)
    yield* enc_PlotColor(v.fill)
    yield* enc_2qfn4txhfq9ik(v.points)
    yield* enc_PlotColor(v.stroke)
    yield f64_b(v.stroke_width)
}
function* enc_2qfn4txhfq9ik(v: readonly type_Point[]): Generator<Uint8Array> {
    yield u32_b(v.length)
    for (const el of v) {
        yield f64_b(el.x)
        yield f64_b(el.y)
    }
}
function* enc_PlotShapeText(v: type_PlotShapeText): Generator<Uint8Array> {
    yield* enc_PlotColor(v.color)
    yield* enc_3bc6k4a4fb69c(v.font_name)
    yield f64_b(v.font_size)
    yield f64_b(v.height)
    yield enc_HorizontalAlign_m[v.horizontal_align]!
    yield f64_b(v.rotation)
    yield* enc_3bc6k4a4fb69c(v.text)
    yield enc_VerticalAlign_m[v.vertical_align]!
    yield f64_b(v.width)
    yield f64_b(v.x)
    yield f64_b(v.y)
}
function* enc_3bc6k4a4fb69c(v: string): Generator<Uint8Array> {
    yield* str_b(v)
}
const enc_HorizontalAlign_m: Record<string, Uint8Array> = {
    "center": u64_b(4238509075905970506n),
    "left": u64_b(15100855298709619960n),
    "right": u64_b(14909819614022829082n),
}
const enc_VerticalAlign_m: Record<string, Uint8Array> = {
    "center": u64_b(4238509075905970506n),
    "bottom": u64_b(3999525445610329589n),
    "top": u64_b(10522114381736613229n),
}
const dec_11yiqyu3zx39b = (c: Cursor) => c.u32() !== 0 ? { value: undefined, error: new Error(c.str()) } : { value: BigInt(c.ptr()) as type_PdfReaderPointer, error: undefined }
const dec_ri0ig35wz65r = (c: Cursor) => c.u32() !== 0 ? { value: undefined, error: new Error(c.str()) } : { value: c.bool(), error: undefined }
const dec_3m5uwmxdt1pj0 = (c: Cursor) => c.u32() !== 0 ? { value: undefined, error: new Error(c.str()) } : { value: {
        bytes_written: c.i64(),
        content: c.bytes(),
        highest_obj_num: c.i64(),
        media: dec_MediaInfo(c),
        page_obj_num: c.i64(),
        xref: c.bytes(),
    }, error: undefined }
const dec_MediaInfo = (c: Cursor) => ({
    media_box: dec_SpatialRectangle(c),
    size: {
        height: c.f64() as type_Pixel,
        width: c.f64() as type_Pixel,
    },
    trim_box: dec_SpatialRectangle(c),
})
const dec_SpatialRectangle = (c: Cursor) => ({
    height: c.f64() as type_Pixel,
    width: c.f64() as type_Pixel,
    x: c.f64() as type_Pixel,
    y: c.f64() as type_Pixel,
})
const dec_2j5tbgjkcu9nf = (c: Cursor) => c.u32() !== 0 ? { value: undefined, error: new Error(c.str()) } : { value: {
        bytes: c.bytes(),
        media: dec_MediaInfo(c),
    }, error: undefined }
const dec_c21lfeuuv8rg = (c: Cursor) => c.u32() !== 0 ? { value: undefined, error: new Error(c.str()) } : { value: BigInt(c.ptr()) as type_ICCPointer, error: undefined }
const dec_2lqnokmzypd36 = (c: Cursor) => c.u32() !== 0 ? { value: undefined, error: new Error(c.str()) } : { value: c.bytes(), error: undefined }
export const CreateFunctions = <T extends number | bigint>(i: RuntimeBridge<T>) => {
    const pa = (v: number): T => i.conv(v)
    const ptr_b = (v: T): Uint8Array => i.memory64 ? u64_b(BigInt(v)) : new Uint8Array(new Uint32Array([Number(v)]).buffer)
    const call = <K extends keyof CallReturn>(name: K, ...args: (number | bigint)[]): CallReturn[K] => i.call(name, ...args) as CallReturn[K]
    const write_args = (...chunks: Uint8Array[]): [
        number,
        number
    ] => {
        const total = chunks.reduce((s, c) => s + c.length, 0)
        const base = i.alloc(total)
        let off = 0
        for (const c of chunks) {
            i.write(base + off, c)
            off += c.length
        }
        return [base, total]
    }
    const write_buf = (data: Uint8Array): [
        number,
        number
    ] => {
        const ptr = i.alloc(data.length)
        i.write(ptr, data)
        return [ptr, data.length]
    }
    const call_with = (fn: string, ...chunks: Uint8Array[]): [
        number,
        number
    ] => {
        const [base, total] = write_args(...chunks)
        const ret = i.call(fn, pa(base), pa(total))
        i.free(base, total)
        return i.unpackReturn(ret)
    }
    const Cursor = (p: number, size: number): Cursor => {
        const raw = i.read(p, size)
        const dv = new DataView(raw.buffer, raw.byteOffset, raw.byteLength)
        let pos = 0
        const i8 = () => { const v = dv.getInt8(pos); pos += 1; return BigInt(v); }
        const u8r = () => { const v = dv.getUint8(pos); pos += 1; return BigInt(v); }
        const i16 = () => { const v = dv.getInt16(pos, true); pos += 2; return BigInt(v); }
        const u16 = () => { const v = dv.getUint16(pos, true); pos += 2; return BigInt(v); }
        const i32 = () => { const v = dv.getInt32(pos, true); pos += 4; return BigInt(v); }
        const u32 = () => { const v = dv.getUint32(pos, true); pos += 4; return v; }
        const f32 = () => { const v = dv.getFloat32(pos, true); pos += 4; return v; }
        const f64 = () => { const v = dv.getFloat64(pos, true); pos += 8; return v; }
        const i64 = () => { const v = dv.getBigInt64(pos, true); pos += 8; return v; }
        const u64 = () => { const v = dv.getBigUint64(pos, true); pos += 8; return v; }
        const i128 = () => { const lo = dv.getBigUint64(pos, true); const hi = dv.getBigInt64(pos + 8, true); pos += 16; return (hi << 64n) | lo; }
        const u128 = () => { const lo = dv.getBigUint64(pos, true); const hi = dv.getBigUint64(pos + 8, true); pos += 16; return (hi << 64n) | lo; }
        const i256 = () => { let v = 0n; for (let j = 0; j < 4; j++) {
            v |= dv.getBigUint64(pos + j * 8, true) << BigInt(j * 64)
        } pos += 32; return v >= (1n << 255n) ? v - (1n << 256n) : v; }
        const u256 = () => { let v = 0n; for (let j = 0; j < 4; j++) {
            v |= dv.getBigUint64(pos + j * 8, true) << BigInt(j * 64)
        } pos += 32; return v; }
        const ptr = () => { if (i.memory64) {
            const v = Number(dv.getBigUint64(pos, true))
            pos += 8
            return v
        } return u32(); }
        const bool = () => !!u32()
        const str = () => {
            const p = ptr()
            const len = ptr()
            const s = UInt8ToString(i.read(p, len))
            i.free(p, len)
            return s
        }
        const bytes = () => {
            const p = ptr()
            const len = ptr()
            const d = new Uint8Array(i.read(p, len))
            i.free(p, len)
            return d
        }
        return { i8, u8: u8r, i16, u16, i32, u32, f32, f64, i64, u64, i128, u128, i256, u256, ptr, bool, str, bytes }
    }
    function* enc_1drvt9yiommpp(v: Uint8Array): Generator<Uint8Array> {
        const [ptr, len] = write_buf(v)
        yield ptr_b(pa(ptr))
        yield ptr_b(pa(len))
    }
    function* enc_PlotPageEntry(v: {
        media: readonly type_PlotMediaEntry[]
        page: type_PlotPage
        shapes: readonly type_PlotShape[]
    }): Generator<Uint8Array> {
        yield* enc_wwbavyyztcvk(v.media)
        yield* enc_PlotPage(v.page)
        yield* enc_2z0guf1ofm03r(v.shapes)
    }
    function* enc_wwbavyyztcvk(v: readonly type_PlotMediaEntry[]): Generator<Uint8Array> {
        yield u32_b(v.length)
        for (const el of v)
            yield* enc_PlotMediaEntry(el)
    }
    function* enc_PlotMediaEntry(v: type_PlotMediaEntry): Generator<Uint8Array> {
        yield* enc_1drvt9yiommpp(v.bytes)
        yield u256_b(v.id)
    }
    return {
        init: (): void => {
            const [base, total] = write_args()
            call(F.init, pa(base), pa(total))
            i.free(base, total)
        },
        destroy: (): void => {
            const [base, total] = write_args()
            call(F.destroy, pa(base), pa(total))
            i.free(base, total)
        },
        open: (file_len: Bytes, get_block_ptr: GetBlockPointer, is_data_avail_ptr: IsDataAvailPointer): Result<PdfReaderPointer> => {
            const [retPtr, retLen] = call_with(F.open, i64_b(BigInt(file_len)), ptr_b(pa(Number(get_block_ptr))), ptr_b(pa(Number(is_data_avail_ptr))))
            const result = dec_11yiqyu3zx39b(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        doc_avail: (reader_handle: PdfReaderPointer): Result<boolean> => {
            const [retPtr, retLen] = call_with(F.doc_avail, ptr_b(pa(Number(reader_handle))))
            const result = dec_ri0ig35wz65r(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        page_avail: (reader_handle: PdfReaderPointer, page_index: PageNumber): Result<boolean> => {
            const [retPtr, retLen] = call_with(F.page_avail, ptr_b(pa(Number(reader_handle))), i64_b(BigInt(page_index)))
            const result = dec_ri0ig35wz65r(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        page_count: (reader_handle: PdfReaderPointer): bigint => {
            const [retPtr, retLen] = call_with(F.page_count, ptr_b(pa(Number(reader_handle))))
            const result = Cursor(retPtr, retLen)
                .i64()
            i.free(retPtr, retLen)
            return result
        },
        open_mem: (data: Uint8Array): Result<PdfReaderPointer> => {
            const [a0_ptr, a0_len] = write_buf(data)
            const [retPtr, retLen] = call_with(F.open_mem, ptr_b(pa(a0_ptr)), ptr_b(pa(a0_len)))
            const result = dec_11yiqyu3zx39b(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        close_mem: (reader_handle: PdfReaderPointer): Result<boolean> => {
            const [retPtr, retLen] = call_with(F.close_mem, ptr_b(pa(Number(reader_handle))))
            const result = dec_ri0ig35wz65r(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        close: (reader_handle: PdfReaderPointer): Result<boolean> => {
            const [retPtr, retLen] = call_with(F.close, ptr_b(pa(Number(reader_handle))))
            const result = dec_ri0ig35wz65r(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        extract_page: (reader_handle: PdfReaderPointer, page_index: PageNumber, last_obj_num: bigint, document_offset: bigint, flush_threshold: bigint): Result<ExtractPageResult> => {
            const [retPtr, retLen] = call_with(F.extract_page, ptr_b(pa(Number(reader_handle))), i64_b(BigInt(page_index)), i64_b(last_obj_num), i64_b(document_offset), i64_b(flush_threshold))
            const result = dec_3m5uwmxdt1pj0(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        split_page: (reader_handle: PdfReaderPointer, page_index: PageNumber): Result<PageResult> => {
            const [retPtr, retLen] = call_with(F.split_page, ptr_b(pa(Number(reader_handle))), i64_b(BigInt(page_index)))
            const result = dec_2j5tbgjkcu9nf(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        convert_jpeg: (data: Uint8Array, resolution: Pixel): Result<PageResult> => {
            const [a0_ptr, a0_len] = write_buf(data)
            const [retPtr, retLen] = call_with(F.convert_jpeg, ptr_b(pa(a0_ptr)), ptr_b(pa(a0_len)), f64_b(resolution))
            const result = dec_2j5tbgjkcu9nf(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        convert_bitmap: (bgra: Uint8Array, size: Rectangle, resolution: Pixel): Result<PageResult> => {
            const [a0_ptr, a0_len] = write_buf(bgra)
            const [retPtr, retLen] = call_with(F.convert_bitmap, ptr_b(pa(a0_ptr)), ptr_b(pa(a0_len)), ...enc_Rectangle(size), f64_b(resolution))
            const result = dec_2j5tbgjkcu9nf(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        icc_create: (data: Uint8Array): Result<ICCPointer> => {
            const [a0_ptr, a0_len] = write_buf(data)
            const [retPtr, retLen] = call_with(F.icc_create, ptr_b(pa(a0_ptr)), ptr_b(pa(a0_len)))
            const result = dec_c21lfeuuv8rg(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        icc_destroy: (handle: ICCPointer): Result<boolean> => {
            const [retPtr, retLen] = call_with(F.icc_destroy, ptr_b(pa(Number(handle))))
            const result = dec_ri0ig35wz65r(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        rasterize_page: (reader_handle: PdfReaderPointer, page_index: PageNumber, resolution: Pixel, icc_handle: ICCPointer): Result<PageResult> => {
            const [retPtr, retLen] = call_with(F.rasterize_page, ptr_b(pa(Number(reader_handle))), i64_b(BigInt(page_index)), f64_b(resolution), ptr_b(pa(Number(icc_handle))))
            const result = dec_2j5tbgjkcu9nf(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
        plot: (entry: PlotPageEntry): Result<Uint8Array> => {
            const [retPtr, retLen] = call_with(F.plot, ...enc_PlotPageEntry(entry))
            const result = dec_2lqnokmzypd36(Cursor(retPtr, retLen))
            i.free(retPtr, retLen)
            return result
        },
    }
}

